export const MODELS = {
  original: {
    id: "original",
    name: "CryoVault Original",
    tag: "Everyday · Travel-ready",
    capacity: "8–12 vials · 1–3 insulin pens",
    spec: "Up to 10h · 0.7 kg",
    badge: null,
  },
  xl: {
    id: "xl",
    name: "CryoVault XL",
    tag: "Home & large collections",
    capacity: "20–25 vials · 4–6 insulin pens",
    spec: "Up to 14h · 1.2 kg",
    badge: "New",
  },
};

// Static bundle metadata (no price)
export const BUNDLES = {
  single: {
    id: "single",
    name: "Single",
    contents: "1× Cooler + 1× Travel Case",
    included: "travel case included, free",
    badge: null,
  },
  bundle: {
    id: "bundle",
    name: "2-Pack Bundle",
    contents: "2× Cooler + 2× Travel Case",
    included: "2× travel cases included, free",
    badge: "Most Popular",
  },
};

// Model × bundle price matrix
export const PRICING = {
  original: {
    single: { price: 149, compareAt: 189, perUnit: null },
    bundle: { price: 249, compareAt: 329, perUnit: 125 },
  },
  xl: {
    single: { price: 199, compareAt: 259, perUnit: null },
    bundle: { price: 359, compareAt: 479, perUnit: 180 },
  },
};

export function getPricing(model, bundle) {
  return PRICING[model]?.[bundle] || PRICING.original.single;
}

export const PLUGS = [
  { id: "EU", label: "EU", flag: "🇪🇺" },
  { id: "UK", label: "UK", flag: "🇬🇧" },
  { id: "US", label: "US", flag: "🇺🇸" },
  { id: "IND", label: "IND", flag: "🇮🇳" },
];
